var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66699 13.3333H13.3337V10.8888H12.0003V12H4.00033V3.99996H5.11144V2.66663H2.66699V13.3333ZM6.44482 4.01441V2.66663H13.3337V4.01441V9.55551H11.9859V5.07028L7.51186 9.54446L6.45599 8.48859L10.9302 4.01441H6.44482Z",
    fill: "#46B1DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemIcon);
export default __webpack_public_path__ + "static/media/SystemIcon.f44436c76ebd9951d437b671254d448a.svg";
export { ForwardRef as ReactComponent };